/**
 * Broken customer pictures → ask the API to load the profile again (POST /contacts/:id/refresh-profile).
 * Meta CDN picture links expire after a few days; the API refreshes them itself when the customer writes again,
 * this covers old chats scrolled into view. At most one ask per contact every 10 minutes (the API debounces too),
 * spaced 250 ms apart so a list full of old links does not fire 50 requests at once.
 */
import { getApi } from '../api'

const GAP_MS = 10 * 60 * 1000
const SPACING_MS = 250
const asked = new Map<string, number>()
const queue: string[] = []
let draining = false

function drain(): void {
  const id = queue.shift()
  if (id === undefined) {
    draining = false
    return
  }
  draining = true
  getApi()
    .refreshProfile(id)
    .catch(() => undefined) // best effort: the initial circle stays, nothing to tell staff
    .finally(() => setTimeout(drain, SPACING_MS))
}

/** Returns true when a refresh was queued (false = asked recently for this contact). */
export function reportBrokenAvatar(contactId: string, now: number = Date.now()): boolean {
  const last = asked.get(contactId)
  if (last !== undefined && now - last < GAP_MS) return false
  asked.set(contactId, now)
  queue.push(contactId)
  if (!draining) drain()
  return true
}

/** Tests only. */
export function resetAvatarAsks(): void {
  asked.clear()
  queue.length = 0
  draining = false
}
